import React from "react";
import { Route } from "react-router-dom";
import Upload from "../pages/ProducaoSTI/upload";
import Relatorio1 from "../pages/ProducaoSTI/relatorio1";
import Relatorio2 from "../pages/ProducaoSTI/relatorio2";
import Relatorio3 from "../pages/ProducaoSTI/relatorio3";
import Relatorio4 from "../pages/ProducaoSTI/relatorio4";
import Index from "../pages/ProducaoSTI/index";
import PageExportsSTI from "../pages/ProducaoSTI/exports";

// Rotas do domínio Produção STI. Exporta só a lista de elementos <Route>
// (sem <BrowserRouter>/<Switch> próprios) para serem montadas dentro do único
// <Switch> consolidado em pages/Principal/index.js (Fase 5). Precisa vir
// ANTES das rotas de STI nesse Switch: são literais mais específicas que o
// "/sti/:unidade" genérico de routerSTI.js e devem ganhar a precedência.
const routesProducaoSTI = [
    <Route key="producaosti-home" exact path="/sti/producaosti/" component={Index} />,
    <Route key="producaosti-upload" exact path="/sti/producaosti/upload" component={Upload} />,
    <Route key="producaosti-relatorio1" exact path="/sti/producaosti/relatorio1" component={Relatorio1} />,
    <Route key="producaosti-relatorio2" exact path="/sti/producaosti/relatorio2" component={Relatorio2} />,
    <Route key="producaosti-relatorio3" exact path="/sti/producaosti/relatorio3" component={Relatorio3} />,
    <Route key="producaosti-relatorio4" exact path="/sti/producaosti/relatorio4" component={Relatorio4} />,
    <Route key="producaosti-relatorio5" exact path="/sti/producaosti/relatorio5" component={PageExportsSTI} />
];

export default routesProducaoSTI;
